import axios from 'axios';
import qs from 'qs';
import {
	keysToCamelCase, keysToSnakeCase, sanitize,
} from '../util/keys-transform';
const instance = axios.create();

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.locale = window.locale;

instance.interceptors.response.use(function (response) {
	if (typeof response.data === 'object') {
		response.data = keysToCamelCase(response.data);
	}
	return response;
}, function (error) {
	/*
	 * Any status codes that falls outside the range of 2xx cause this function to trigger
	 * Do something with response error
	 */
	return Promise.reject(error);
});

instance.interceptors.request.use(function (config) {
	if (!(config.data instanceof FormData)) {
		config.data = keysToSnakeCase(config.data);
	} else {
		let pairs = {
		};

		for (const [key, val, ] of config.data.entries()) {
			pairs[key] = val;
		}
		pairs = keysToSnakeCase(pairs);
		config.data = new FormData();
		for (const key in pairs) {
			config.data.append(key, pairs[key]);
		}
	}

	config.paramsSerializer = (params) => {
		return qs.stringify(keysToSnakeCase(sanitize(params)), {
			arrayFormat: 'brackets',
		});
	};

	return config;
});

export {
	instance as axios,
};
